import EnvVariableContainer from './EnvVariableContainer';

export default EnvVariableContainer;
